import React, { Component } from 'react';

// Redux
import { connect } from 'react-redux';
import {
  PROFILE,
  PROFILE_ERROR,
  PROFILE_LOADED,
} from '../store/actions/firebase';

// import { cleanDB } from '../store/actions/firestore';

const firebaseConnect = (WrappedComponent) => {
  class FirebaseConnect extends Component {
    constructor(props) {
      super(props);
      this.state = {
        auth: props.auth,
        unsubscribe: null,
      };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.auth.isEmpty !== prevState.auth.isEmpty) {
        return {
          auth: nextProps.auth,
        };
      }
      return null;
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevState.auth !== this.state.auth) {
        if (this.state.auth.isEmpty) {
          if (this.state.unsubscribe) {
            this.state.unsubscribe();
          }
        } else {
          this.setState({
            ...this.state,
            unsubscribe: this.props.firestore
              .collection('users')
              .doc(this.state.auth.uid)
              .onSnapshot(
                (doc) => {
                  if (doc.exists) {
                    this.props.dispatch({ type: PROFILE, payload: doc.data() });
                  } else {
                    this.props.dispatch({ type: PROFILE, payload: null });
                  }
                  this.props.dispatch({ type: PROFILE_LOADED });
                },
                (error) => {
                  this.props.dispatch({ type: PROFILE_ERROR, payload: error });
                  this.props.dispatch({ type: PROFILE_LOADED });
                }
              ),
          });
        }
      }
    }

    componentWillUnmount() {
      if (this.state.unsubscribe) {
        this.state.unsubscribe();
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  const mapStateToProps = ({ firebase: { auth } }) => ({
    auth,
  });

  return connect(mapStateToProps)(FirebaseConnect);
};

export default firebaseConnect;
